import * as React from "react";
import { css } from "@emotion/core";
import { ReactNode, useState, useEffect } from "react";

const height = css`
  height: 90px;
`;

const alignRightOnSmallScreenCss = css`
  @media (max-width: 576px) {
    justify-content: flex-start;
  }
`;

export const FixedFooter = (props: {
  children: ReactNode;
  alignRightOnSmallScreen?: boolean;
}) => {
  const [smallWindow, setSmallWindow] = useState(false);

  useEffect(() => {
    const handler = () => {
      setSmallWindow(window.innerHeight < 440);
    };
    window.addEventListener("resize", handler);
    handler();
    return () => {
      window.removeEventListener("resize", handler);
    };
  });

  return (
    <div
      css={css`
        position: relative;
        ${smallWindow
          ? css`
              margin: 0 -20px;

              @media (min-width: 576px) {
                margin: 0 -50px;
              }
            `
          : ""}

        .arrow-link {
          margin-left: 90px;

          @media (max-width: 320px) {
            margin-left: 70px;
          }
        }
      `}
    >
      <div css={height} />
      <div
        css={css`
          position: ${smallWindow ? "absolute" : "fixed"};
          bottom: 0;
          left: 0;
          width: 100%;
          display: flex;
          justify-content: center;
          border-top: #dbdbdb solid 1px;
          background: #fff;
          padding: 0 20px;
          ${height}
        `}
      >
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            ${props.alignRightOnSmallScreen ? alignRightOnSmallScreenCss : ""}
            flex-direction: row-reverse;
            align-items: center;
            width: 100%;
            max-width: 400px;
            ${height}
          `}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
};
